import Resource from "../base/resource";

class _360ImageHotspot extends Resource {

    constructor(props) {
        super(props);
    }

    async load() {
    }

    setState(state) {
        if(!state.hotSpotName && !state.model) {
            imageHotSpotFeature.onChangeShowAll360Images(false);
            return;
        }
        const stateName = "panoramic-image\\" + this.resourceId;

        const position = new THREE.Vector3(state.position[0], state.position[1], state.position[2]);
        const orientation = new THREE.Vector3(0, 0, 0, 1); /// default for all 360 Images
        const imageCount = 1; /// default for all 360 Images

        imageHotSpotFeature.getImageHotSpotInfoFromServer(state.model.id, stateName, position, state.hotSpotName, state.addToType, imageCount, orientation);
        imageHotSpotFeature.hotSpotManager.changeSpotVisibility(state.hotSpotName, state.isVisible);

        if(state.isVisible && state.showPreview){
            imageHotSpotFeature.processPanoramaImages(state.hotSpotName);
        }
    }

    mergeStates(initialState) {
        if (this.states.length === 0) {
            return initialState;
        }

        let finalState = initialState;
        this.states.forEach(state => {
            finalState.hotSpotName = state.hotSpotName;
            finalState.model = state.model;
            finalState.addToType = state.addToType === 'Scene' ? AddToType360ImageEnum.SCENE : AddToType360ImageEnum.MODEL;
            finalState.position = state.position ? state.position : finalState.position;
            finalState.showPreview = state.showPreview;
            finalState.isVisible = state.isVisible ? state.isVisible : finalState.isVisible;
        });

        this.states = [];
        return finalState;
    }

    getDefaultState() {
        return {
            isVisible: false,
            showPreview: false,
            addToType: AddToType360ImageEnum.MODEL,
            position: [0, 0, 0]
        }
    }
}

export default _360ImageHotspot;
